import React, { FC } from "react";
import ReusableAccordian from "../ReusableAccordion";
import {
  Typography,
  Select,
  MenuItem,
  Paper,
  FormControl,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useConfigSelection from "./useConfigSelection";

const StyledTypography = styled(Typography)({
  fontSize: 20,
  fontWeight: "bold",
  paddingRight: 20,
});

const StyledDivCol = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: " center",
  width: "100%",
  paddingTop: 20,
});

interface BifoldCornerConfigProps {
  hideHandlesWithEvenConfigs: (hide: boolean) => void;
}

const BifoldCornerConfigAccordian: FC<BifoldCornerConfigProps> = ({
  hideHandlesWithEvenConfigs,
}) => {
  const {
    handleChangeLeft,
    handleChangePrimary,
    handleChangeRight,
    imageLeft,
    imageRight,
    cornerOptionsLeft,
    cornerOptionsRight,
    error,
    cornerConfigLeft,
    cornerConfigRight,
    primaryDoor,
    oddEven,
    stileCategory,
  } = useConfigSelection(hideHandlesWithEvenConfigs);

  return (
    <ReusableAccordian
      accordionName="configuration"
      heading="Configuration"
      secondaryHeading="Select a configuration"
      required5={true}
      colOrRow="col"
    >
      <StyledDivCol>
        <Typography style={{ fontWeight: "bold", paddingRight: 40 }}>
          Primary Door:
          <span style={{ color: "red", fontSize: 22 }}>*</span>
        </Typography>
        <FormControl component="fieldset">
          <FormControlLabel
            value="end"
            control={
              <Radio
                color="primary"
                checked={primaryDoor === "Left"}
                onChange={handleChangePrimary}
                value="Left"
                disabled={oddEven}
              />
            }
            label="Left"
            labelPlacement="end"
          />
          <FormControlLabel
            value="end"
            control={
              <Radio
                color="primary"
                checked={primaryDoor === "Right"}
                onChange={handleChangePrimary}
                value="Right"
                disabled={oddEven}
              />
            }
            label="Right"
            labelPlacement="end"
          />
        </FormControl>
      </StyledDivCol>

      {primaryDoor && (
        <>
          <RowLayout style={{ marginTop: -20 }}>
            <ColLayout>
              <RowLayout>
                <StyledTypography>Left Configuration:</StyledTypography>
                <Select
                  value={cornerConfigLeft}
                  onChange={handleChangeLeft}
                  variant="outlined"
                  margin="dense"
                  size="small"
                  style={{ marginRight: 60, backgroundColor: "white" }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {cornerOptionsLeft?.map((itm) => (
                    <MenuItem
                      key={itm}
                      value={itm.replace(" (Wider Panels)", "")}
                    >
                      {itm}
                    </MenuItem>
                  ))}
                </Select>
              </RowLayout>

              {imageLeft &&
              typeof imageLeft === "object" &&
              cornerConfigLeft ? (
                <Paper
                  elevation={3}
                  style={{
                    marginRight: 60,
                    backgroundColor: "white",
                    padding: 10,
                  }}
                >
                  <img
                    src={
                      primaryDoor === "Right" && imageLeft.image2
                        ? imageLeft.image2
                        : stileCategory === "Pico" &&
                          imageLeft.picoImage &&
                          primaryDoor === "Left"
                        ? imageLeft.picoImage
                        : imageLeft.image
                    }
                    alt="corner left"
                  />
                </Paper>
              ) : (
                <div style={{ width: 300, height: 232, marginRight: 60 }} />
              )}
            </ColLayout>

            <ColLayout>
              <RowLayout>
                <StyledTypography style={{ marginLeft: 60 }}>
                  Right Configuration:
                </StyledTypography>
                <Select
                  value={cornerConfigRight}
                  onChange={handleChangeRight}
                  variant="outlined"
                  margin="dense"
                  size="small"
                  style={{ backgroundColor: "white" }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {cornerOptionsRight?.map((itm) => (
                    <MenuItem
                      key={itm}
                      value={itm.replace(" (Wider Panels)", "")}
                    >
                      {itm}
                    </MenuItem>
                  ))}
                </Select>
              </RowLayout>

              {imageRight &&
              typeof imageRight === "object" &&
              cornerConfigRight ? (
                <Paper
                  elevation={3}
                  style={{
                    marginLeft: 60,
                    backgroundColor: "white",
                    padding: 10,
                  }}
                >
                  <img
                    src={
                      primaryDoor === "Left" && imageRight.image2
                        ? imageRight.image2
                        : stileCategory === "Pico" &&
                          imageRight.picoImage &&
                          primaryDoor === "Right"
                        ? imageRight.picoImage
                        : imageRight.image
                    }
                    alt="corner right"
                  />
                </Paper>
              ) : (
                <div style={{ width: 300, height: 232, marginLeft: 60 }} />
              )}
            </ColLayout>
          </RowLayout>

          {oddEven && (
            <StyledDivCol>
              <Typography>
                * Primary Door defaults to side with odd configuration
              </Typography>
            </StyledDivCol>
          )}

          {error && (
            <StyledDivCol>
              <Typography style={{ color: "red" }}>{error}</Typography>
            </StyledDivCol>
          )}
        </>
      )}
    </ReusableAccordian>
  );
};

export default BifoldCornerConfigAccordian;
